module.exports = __webpack_public_path__ + "static/media/warning.f7eacd75.svg";